import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, Reveal, TempImage } from "../components/common";
import { INVOLVE_WAYS, IMAGES } from "../data/site";

export default function GetInvolved() {
  return (
    <>
      <PageHero
        overline="Get Involved"
        title="Take Part in the Work"
        copy="There are many ways to support Susanna Charitable Trust — through giving, time, partnership and advocacy. Choose the one that fits you."
      />
      <section className="pb-24 md:pb-32">
        <div className="max-w-[90rem] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal className="lg:sticky lg:top-32">
              <TempImage src={IMAGES.getInvolved.url} alt={IMAGES.getInvolved.alt} ratio="aspect-[4/5]" real />
            </Reveal>
          </div>
          <div className="lg:col-span-7 space-y-6">
            {INVOLVE_WAYS.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.06}>
                <div
                  data-testid={`involve-card-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group bg-white border border-charcoal/5 rounded-2xl p-8 md:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-shadow duration-500"
                >
                  <span className="font-mono text-sm text-charcoal/40">{w.number}</span>
                  <h3 className="mt-3 font-serif text-3xl font-light tracking-tight group-hover:text-terracotta transition-colors duration-300">
                    {w.title}
                  </h3>
                  <p className="mt-4 text-sm md:text-base leading-relaxed text-charcoal/70">{w.description}</p>
                  <Link
                    to={w.to}
                    {...(w.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    data-testid={`involve-cta-${w.title.toLowerCase().replace(/\s+/g, "-")}`}
                    className="mt-6 inline-flex items-center gap-2 rounded-full bg-charcoal text-warmwhite px-7 py-3 text-sm font-semibold hover:bg-terracotta hover:-translate-y-0.5 transition-all duration-300"
                  >
                    {w.cta} <ArrowUpRight className="h-4 w-4" />
                  </Link>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
